const DARK = '000000';
const LIGHT = 'FFFFFF';
const FALLBACK = '777a86';

function getContrastYIQ(hex) {
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);
  const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;
  return (yiq >= 128) ? DARK : LIGHT;
}

function stripHash(color) {
  return color?.[0] === '#' ? color.slice(1) : color;
}

function normalizeColor(color) {
  const strippedColor = stripHash(color);
  if (typeof strippedColor !== 'string') return FALLBACK;
  if (strippedColor.length === 3) {
    return strippedColor.split('').map((char) => `${char}${char}`).join('');
  }
  if (strippedColor.length !== 6) return FALLBACK;
  return /^[0-9a-fA-F]{6}$/.test(strippedColor) ? strippedColor : FALLBACK;
}

function applyContrastColors(el, color) {
  const normalizedColor = normalizeColor(color);
  el.style.backgroundColor = `#${normalizedColor}`;
  el.style.color = `#${getContrastYIQ(normalizedColor)}`;
}

export default {
  mounted(el, binding) {
    applyContrastColors(el, binding.value);
  },
  updated(el, binding) {
    applyContrastColors(el, binding.value);
  },
};
